/** Field keys match backend regex $or attributes (or client filter keys). */

export const INSTALLMENT_CARD_SEARCH_FIELDS = [
  'installmentCardId',
  'customerId',
  'location',
  'routeId',
  'stockId',
  'itemId',
  'reference',
] as const;

export const ZEETTU_CARD_SEARCH_FIELDS = [
  'zeettuCardId',
  'customerId',
  'location',
  'routeId',
  'reference',
] as const;

export const CUSTOMER_SEARCH_FIELDS = [
  'firstName',
  'lastName',
  'email',
  'mobileNumber',
  'nic',
  'customerId',
  'referance',
  'groupId',
  'packageId',
] as const;

export const EXPENSE_SEARCH_FIELDS = [
  'expenseVoucherId',
  'vendorName',
  'remark',
  'reference',
] as const;

export const ENQUIRY_SEARCH_FIELDS = [
  'enquiryId',
  'customerId',
  'routeId',
  'deliveryPackageId',
  'description',
] as const;

export const RECOVERY_ARREARS_SEARCH_FIELDS = [
  'installmentId',
  'installmentCardId',
  'customerId',
  'reference',
] as const;

export const REPLACEMENT_NOTE_SEARCH_FIELDS = [
  'rnId',
  'customer',
  'referenceDocumentNumber',
  'salesperson',
  'processedBy',
  'manufacturer',
] as const;

export const RTS_SEARCH_FIELDS = [
  'rtsId',
  'supplierId',
  'supplierName',
  'purchaseOrderId',
  'supplierReference',
  'remark',
] as const;

export const TRIP_SEARCH_FIELDS = [
  'tripId',
  'employeeId',
  'routeId',
  'vehicleId',
] as const;

export const PDR_FINISH_SEARCH_FIELDS = [
  'stockId',
  'itemName',
  'model',
  'brand',
  'color',
] as const;

export const NAV_FEATURE_SEARCH_FIELDS = ['name', 'path'] as const;
